export const AUTH_ERRORS = {
  AUTHENTICATION_ERROR: "AUTHENTICATION_ERROR" as "AUTHENTICATION_ERROR",
  RESET_PASSWORD_ERROR: "RESET_PASSWORD_ERROR" as "RESET_PASSWORD_ERROR",
  CONFIRM_PASSWORD_RESET_ERROR: "CONFIRM_PASSWORD_RESET_ERROR" as "CONFIRM_PASSWORD_RESET_ERROR",
  FETCH_ME: "FETCH_ME" as "FETCH_ME",
};
